"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSContentTargeterComponent = void 0;
const core_1 = require("@angular/core");
const _ = require("underscore");
const contenttargeter_service_1 = require("./../services/contenttargeter.service");
const account_service_1 = require("./../../shared/services/account.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const router_1 = require("@angular/router");
class CSContentTargeterComponent {
    constructor(contentTargetService, modalService, router, accountService) {
        this.contentTargetService = contentTargetService;
        this.modalService = modalService;
        this.router = router;
        this.accountService = accountService;
        this.contentTargeterStatusEmitter = new core_1.EventEmitter();
    }
    ngOnInit() {
        this.getAccountDetails();
    }
    open(content) {
        this.modelRef = this.modalService.open(content, { size: 'lg' });
    }
    getContentTargeterData() {
        this.loader = true;
        this.contentTargetService.getContentTargeterData(this.contentTargeterId).subscribe((data) => {
            this.loader = false;
            if (data !== null) {
                this.promoData = data.contentData;
                this.contentType = data.type;
                if (this.promoData.toString().includes('promoContent')) {
                    this.hideContent = true;
                }
                if (this.promoData.toString().includes('promoContent') && sessionStorage.getItem('promoDisplayed') !== 'true') {
                    this.open(this.promoContent);
                    this.modelRef.result.then(() => {
                        this.setMainDivVisibility('block');
                    }, () => {
                        this.setMainDivVisibility('block');
                    });
                    this.hideContent = true;
                    this.setMainDivVisibility('none');
                    sessionStorage.setItem('promoDisplayed', 'true');
                }
            }
            else {
                this.loader = false;
            }
            this.contentTargeterStatusEmitter.emit(this.promoData && !this.hideContent);
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.contentTargeterStatusEmitter.emit(false);
        });
    }
    navigateToAccountSettings() {
        this.modelRef.close();
        this.setMainDivVisibility('block');
        this.router.navigate(['/']);
    }
    setMainDivVisibility(visibility) {
        const footerElement = document.getElementById('footer-content');
        document.getElementById('mainDiv').style.display = visibility;
        if (footerElement) {
            footerElement.style.display = visibility;
        }
    }
    getAccountDetails() {
        this.accountService.getAccountDetails(true).subscribe((details) => {
            if (this.pageForContentTargeter === 'overview') {
                if (details.hasWirelessAccount) {
                    this.accountService.isApplyForWirelessBundleDiscount().subscribe((res) => {
                        if (res === true) {
                            this.contentTargeterId = '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MoreUnlimitedDiscountInOverview';
                            this.getContentTargeterData();
                        }
                    });
                }
            }
            else {
                if (details.businessAccount) {
                    this.customerType = details.accountType;
                }
                this.isHSAccountLinked = (details.accountLinked && details.fiberAccount);
                this.setContentTargeterId();
            }
        });
    }
    getFiberAccountDetails() {
        this.accountService.checkIfWirelessDiscountAvailable().subscribe((discountResponse) => {
            if (!_.isEmpty(discountResponse) && discountResponse.showWirelessDiscount) {
                this.contentTargeterId = '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MyBundleTvDashboardBanner';
            }
            else {
                this.contentTargeterId = '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MMAHSHome';
            }
            this.getContentTargeterData();
        });
    }
    setContentTargeterId() {
        switch (this.customerType) {
            case 'WIRELESS':
                this.contentTargeterId = '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MMAWirelessHome';
                break;
            case 'HOME_SERVICE':
                this.contentTargeterId = this.isHSAccountLinked ? '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MMAHSHome'
                    : this.getFiberAccountDetails();
                break;
            case 'BUSINESS':
                this.contentTargeterId = '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MMABusinessHome';
                break;
            case 'MS_GOV_STATE_AGENCY':
                this.contentTargeterId = '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MMAGovernmentHome';
                break;
            default:
                this.contentTargeterId = '/atg/registry/RepositoryTargeters/CellularSouth/TopBarPromo/MMAHome';
                break;
        }
        if (this.contentTargeterId) {
            this.getContentTargeterData();
        }
    }
}
exports.CSContentTargeterComponent = CSContentTargeterComponent;
//# sourceMappingURL=contenttargeter.component.js.map